// extracted by mini-css-extract-plugin
module.exports = {"adModal":"ModalAd_adModal__-yRzp","circle":"ModalAd_circle__3e0ZL","join":"ModalAd_join__4Ll2K","DISCOUNT_AD":"ModalAd_DISCOUNT_AD__2uneE","GENERIC_AD":"ModalAd_GENERIC_AD__2sZlh"};